import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';

import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
  catchError,
} from 'rxjs/operators';
import { GroupSharingService } from '../../../../../features/group-sharing/group-sharing.service.component';
import { COMMA, ENTER, I, P } from '@angular/cdk/keycodes';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HotToastService } from '@ngneat/hot-toast';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { StripePurchaseService } from '../../../../../features/bulk-purchase/stripe-purchase.service';
import { User } from '../../../../../features/bulk-purchase/stripe-purchase-popup/stripe-purchase-popup.component';
import { HttpErrorResponse } from '@angular/common/http';
import {RsvpService} from "../../../../../core/services/rsvp/rsvp.service";
import {RSVPStatus} from "../../../../../core/models/rsvp.models";

@Component({
  selector: 'app-ticket-assign-remove-popup',
  templateUrl: './ticket-assign-remove-popup.component.html',
  styleUrls: ['./ticket-assign-remove-popup.component.css'],
})
export class TicketAssingRemoveComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TicketAssingRemoveComponent>,
    public groupSharingService: GroupSharingService,
    private _snackBar: MatSnackBar,
    private toast: HotToastService,
    public spotlightService: SpotlightService,
    private readonly stripePurchaseService: StripePurchaseService,
    @Optional() @Inject(MAT_DIALOG_DATA) public MatIncomingdata: any,
    private readonly rsvpService: RsvpService
  ) {}
  filteredOptions: any;
  options: User[] = [];
  myControl = new FormControl();
  invitationEmail = new FormControl('', Validators.email);
  emptyTicketCount: FormControl = new FormControl();
  invitedEmails: string[] = [];
  selectedUsers: any;
  selectedUserID: number;
  selectedUsername: string = '';
  @ViewChild('userInput') userDetailsInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  eventId: string;
  invalidUserIds: boolean = false;
  loaded = false;
  error = false;
  buttonActive = false;
  userDetails: any;
  filterHasLength = true;
  ticketGuests: any[] = [];
  pageUrl = '';
  ticketDetails: any;
  tableData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  RsvpGuests: any[];
  selectedUserIds: number[] = [];
  guestUser: any[];
  groupName = '';
  userInput = new FormControl('');
  displayedColumns = ['guestname', 'rsvpStatus', 'action'];
  availableTickets: number;
  validInput: boolean = true;
  userselected: boolean = false;
  isUserpresentInRsvp:boolean=false;
  rsvpTooltips: Record<RSVPStatus, string> = {
    [RSVPStatus.UNKNOWN]:
      'The participant has not responded to the RSVP. They can still join the Group Sharing experience.',
    [RSVPStatus.ACCEPTED]: 'The participant has accepted the RSVP!',
    [RSVPStatus.REJECTED]:
      'The participant has rejected the RSVP. The host may remove the participant if they wish.',
  };

  rsvpStatusDisplayNames: Record<RSVPStatus, string> = {
    ACCEPTED: 'Accepted',
    REJECTED: 'Declined',
    UNKNOWN: 'Unknown',
  };

  ngOnInit(): void {
    this.guestUser = [];
    this.ticketDetails = this.MatIncomingdata;
    this.availableTickets = this.ticketDetails.tickets
      ? this.ticketDetails.tickets
      : 0;
    this.getRsvpList(
      Number(this.MatIncomingdata.hostId),
      this.MatIncomingdata.paymentSessionId
    );
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((val) => {
        return this.filter(val || '');
      })
    );
  }
  closeDialog() {
    this.dialogRef.close();
  }
  filter(val: string): Observable<any[]> {
    if (val.length > 3) {
      return this.groupSharingService.getPublicUsersList(val).pipe(
        map((response) =>
          response.filter((option) => {
            this.guestUser.push(option);
            const userData = JSON.parse(
              localStorage.getItem('userData') || '{}'
            );
            return (
              option.userId !== userData.userId &&
              (!this.selectedUsers ||
                !this.selectedUsers.find((p) => p.id === option.userId))
            );
          })
        ),
        catchError(() => {
          return EMPTY;
        })
      );
    } else if (val.length >= 3 && this.guestUser.length === 0) {
      this.toast.info(`User not found on the Creatics Platform`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 3000,
      });
      return EMPTY;
    } else {
      return EMPTY;
    }
  }
  selectedItems(event): void {
    this.guestUser.find((item) => {
      if (item.value === event.option.value) {
        this.selectedUserID = item.userId;
        this.selectedUsername = item.value;
        this.buttonActive = true;
        this.userselected = true;
        console.log(this.selectedUserID, '----------selected ID-----------');
      }
    });
  }
  deSelectItem() {
    this.userselected = false;
    this.selectedUserID = null;
    this.selectedUsername = null;
    this.buttonActive = false;
    this.myControl.reset();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }

  assignTicket() {
    console.log(
      this.selectedUserID,
      this.myControl.value,
      '----------user sent-----------'
    );
    if (this.selectedUsername === null || this.selectedUsername === '') {
      this.validInput = false;
      this.buttonActive = false;
    } else if (this.availableTickets === 0) {
      console.log('Empty tickets not available to assing');
    }
    else {
      console.log(this.ticketDetails,'------ticket details------', this.selectedUserID);
      this.validInput = true;
      this.stripePurchaseService
        .assignTicket(this.ticketDetails.paymentSessionId, this.selectedUserID)
        .subscribe({
          next: (res) => {
            if(res.hasOwnProperty('status')){
              this._snackBar.open(res.message, '', {
                duration: 2000,
                horizontalPosition: 'end',
                verticalPosition: 'top',}
                )
                return ;
            }
            else{
              console.log(res,'------assing ticket response-----');
            this._snackBar.open('Ticket assigned successfully', '', {
              duration: 2000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
            this.getRsvpList(
              Number(this.MatIncomingdata.hostId),
              this.MatIncomingdata.paymentSessionId
            );
            this.myControl.reset();
            this.deSelectItem();
            this.availableTickets = res.remainingHostTicketCount;
            }
            return;
          },
          error: (err: any) => {
            console.log(err, "ticket assign API Error");
            this._snackBar.open("Error while assigning ticket", '', {
              duration: 5000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          },
        });
    }
  }

  removeTicket(paymentSessionId: string, guestUserId: number) {
    this.stripePurchaseService
      .removeTicket(paymentSessionId, guestUserId)
      .subscribe({
        next: (res) => {
          this._snackBar.open('Ticket removed successfully', '', {
            duration: 2000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });

          this.availableTickets = res.remainingHostTicketCount;
          this.getRsvpList(
            Number(this.MatIncomingdata.hostId),
            this.MatIncomingdata.paymentSessionId
          );
        },
        error: (err: any) => {
          this._snackBar.open("Something went wrong..", '', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        },
      });
  }
  getRsvpList(hostuserId, paymentSessionId) {
    this.RsvpGuests = [];
    this.rsvpService
      .listRsvpStatusForType(hostuserId, paymentSessionId)
      .subscribe({
        next: (response) => {
          response.forEach((rsvpRecord) => {
            this.groupSharingService
              .getUserProfileDetails(rsvpRecord.participantId)
              .subscribe({
                next: (data) => {
                  const fullName = data.firstName + ' ' + (data.lastName!=null?data.lastName:'');
                  console.log(fullName);
                  this.RsvpGuests.push({
                    guestname: fullName,
                    rsvpStatus: rsvpRecord.status,
                    action: 'remove',
                    hostId: rsvpRecord.participantId,
                  });
                  this.loaded = true;
                },
                error: (error:any) => {
                  this.error = true;
                },
                complete: () => {
                  console.log(this.RsvpGuests);
                  this.tableData.next(this.RsvpGuests);
                },
              });
          });

          console.log(this.tableData, '--------------RSVP records------------');
          this.loaded = false;
        },
        error: (rsvpError) => {
          console.error('Error fetching RSVP data:', rsvpError);
          this.loaded = false;
          this.error = true;
        },
      });
  }

  closePopup() {
    this.dialogRef.close();
  }

  removeParticipant(user: any): void {
    const index = this.RsvpGuests.indexOf(user);
    const idIndex = this.RsvpGuests.indexOf(user.id);
    if (index >= 0) {
      this.RsvpGuests.splice(index, 1);
      this.removeTicket(this.ticketDetails.paymentSessionId, user.hostId);
    }
    this.tableData.next(this.RsvpGuests);
  }
}
